module.exports = __webpack_public_path__ + "img/footer.de504bec.png";